import type { CartRouteStage } from '../types';
import { PAYMENT_STATUS } from '../enums';

/**
 * Which of the three cart views a status belongs to.
 *
 * Returns null for a status with no view — canceled, deleted, expired, reversed. Callers send those
 * users to Animals in Care.
 *
 * Kept in one place because two callers need the same answer: the route guards, which decide whether
 * you may stay on the page you asked for, and the session recovery, which decides where to put you
 * after the API refuses a mutation.
 *
 * Pure on purpose — no store import, so it stays usable from the axios interceptor.
 */
function getCartRouteStage(status?: PAYMENT_STATUS | null): CartRouteStage | null {
  const { ACTIVE, COMPLETED, PAID, PENDING, PENDING_OFFSITE_PAYMENT } = PAYMENT_STATUS;

  if (!status) return null;

  if ([PAID, PENDING, PENDING_OFFSITE_PAYMENT].includes(status)) return 'pending';

  if (status === COMPLETED) return 'completed';

  if (status === ACTIVE) return 'active';

  return null;
}

export { getCartRouteStage };
